import { inject, Service } from '@angular/core';
import { AnalyticsService } from '@app/core/services/mixpanel/analytics.service';

@Service()
export class CartonGroupingPivotTableMixpanelEventTrackingService {
  private _analyticsService = inject(AnalyticsService);

  trackExportPallets(): void {
    this._analyticsService.track('Export Pallets');
  }
}
